<template>
    <div id="centerRight2">
      <div class="bg-color-black">
        <div class="d-fle title11">
          <span class="fs-xl text_title commonTitle">医院临床织物滞留数量</span>
        </div>
        <div class="chart-title">
          <div class="title"></div>
          <div class="num">数量</div>
          <div class="percent">滞留率</div>
        </div>
        <div class="d-flex flex-column body-box title22">
          <Chart v-if="showChart" :listData="listData" type="loss" />
        </div>
      </div>
    </div>
</template>

<script>
import Chart from './chart.vue'
import * as api from '@/api/index'
import { sortArrayByKey } from '../../utils';
export default {
  data() {
    return {
      showChart:false,
      listData: [
        // {
        //   customerName: "xxxxxxx医院",
        //   num: "100",
        //   rate:'30',
        // },
        // {
        //   customerName: "xxxxxxx医院",
        //   num: "200",
        //   rate:'50',
        // }, {
        //   customerName: "xxxxxxx医院",
        //   num: "300",
        //   rate:'20',
        // }, 
        // {
        //   customerName: "xxxxxxx医院",
        //   num: 400,
        // },
        // {
        //   customerName: "xxxxxxx医院",
        //   num: "200",
        // }, {
        //   customerName: "xxxxxxx医院",
        //   num: "300",
        // }, {
        //   customerName: "xxxxxxx医院",
        //   num: 400,
        // },
      ],
      params: {
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        customerId: ''
      },
      result: [],
      intervalId: null // 用于存储定时器的 ID
    }
  },
  components: {
    Chart
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem('userInfo'))
    this.params.customerId = this.$route.query.customerId

    this.getSkuPreLossCustomer()

    // 设置定时器，每隔 30 分钟获取一次数据
    this.intervalId = setInterval(() => {
      this.getSkuPreLossCustomer();
    }, 30 * 60 * 1000); // 30 分钟
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getSkuPreLossCustomer(){
      const res = await api.getSkuPreLossCustomer({})
      console.error(res.Result)
      this.$nextTick(() => {
        this.showChart = true
        let total = res.Result.reduce((c, R) => c + R.numStatus, 0)
        res.Result.forEach(item => {
          item.percent = ((item.numStatus / item.num)).toFixed(2)
          item.percent = parseFloat(item.percent)
          item.percentNew = item.numStatus / total * 100
          item.showNum = item.numStatus
        });
        this.listData = res.Result
        this.listData = sortArrayByKey(this.listData,'showNum')
        console.log(res.Result,'loss')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#centerRight2 {
 // $box-height: 410px;
 // $box-width: 500px;
  //padding: 16px;
  // height: $box-height;
  width: 100%;
  height: 100%!important;
  padding-bottom: 0px;
  .bg-color-black{
    border-radius: 0!important;
    // padding: 5px;
    height: 100%!important;
    // width: $box-width;
    border-radius: 10px;
    padding: 0 20px;
  }

  .body-box {
    //border-radius: 10px;
    overflow: hidden;
    padding-bottom: 0px;

    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }

  .title11{
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    //height: 20%;
    padding-top:5%;
    padding-bottom:3%
  }
  .title22{
    height: 60%;
    //position: relative;
  }
  
  .chart-title{
    display: flex;
    flex-direction: row;
    height: 10%;
    .title{
        width: 50%;
    }
    .num{
        width: 35%;
    }
    .percent{
        width: 15%;
    }
 }
}
</style>
